import React from 'react';

const AlignTextCenterIcon = props => (
  <svg viewBox="0 0 16 16" {...props}>
    <path
      stroke="none"
      fillRule="evenodd"
      transform="translate(-12.000000, -55.000000)"
      d="M12,55 L28,55 L28,57 L12,57 L12,55 Z M16,59 L24,59 L24,60 L16,60 L16,59 Z M12,62 L28,62 L28,64 L12,64 L12,62 Z M16,66 L24,66 L24,67 L16,67 L16,66 Z M12,69 L28,69 L28,71 L12,71 L12,69 Z"
    />
  </svg>
);

export default AlignTextCenterIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/align-text-center-icon.js